<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <!-- <right-nav></right-nav> -->
    <home-nav></home-nav>
    <div>
      <div class="w">
        <div class="site-nav">
          <router-link :to="{ name: 'index' }">首页</router-link>>
          <router-link :to="{ name: 'user-center' }">个人中心</router-link>>
          订单详情
        </div>
        <left-userinfo state="3"></left-userinfo>
        <div class="right-refund-wrap">
          <div class="title">
            <h2>售后记录</h2>
            <h3 @click="toKf">
              <i class="el-icon iconPClianxikefu2"></i>
              <label class=" margin-left-10">联系客服</label>
            </h3>
          </div>
          <table class="order-detail-list-wrapper" cellspacing="0">
            <thead>
              <tr class="order-list-thead">
                <th style="width: 330px !important">商品名称</th>

                <th>申请时间</th>
                <th>申请数量</th>
                <th>当前状态</th>
              </tr>
            </thead>
            <tbody>
              <tr class="order-list-body">
                <td class="clearfix">
                  <img
                    :src="
                      orderInfo.order_info && orderInfo.order_info.product_image
                    "
                    alt="goods"
                  />
                  <p>{{ orderInfo.order_product_name }}</p>
                </td>

                <td>{{ orderInfo.date_added }}</td>
                <td>{{ orderInfo.number }}</td>
                <td class="red_word">{{ orderInfo.status_name }}</td>
              </tr>
            </tbody>
          </table>
          <div
            class="schedule"
            v-if="
              orderInfo.workorder_schedule_record_flag === 1 &&
                orderInfo.workorder_schedule_record &&
                orderInfo.workorder_schedule_record.length > 0
            "
          >
            <div class="o-title">
              跟进记录
              <el-popover
                placement="bottom-start"
                width="200"
                trigger="hover"
                content="商品提交售后，将由供应商负责商品的退换/维修服务。上班族客服将及时为您跟进，您可在此查看上班族客服跟进记录。"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </div>
            <div class="o-message">
              {{ orderInfo.workorder_schedule_record[0].content
              }}<span
                v-if="orderInfo.workorder_schedule_record[0].express_company"
                >快递公司：{{
                  orderInfo.workorder_schedule_record[0].express_company
                }}，</span
              ><span
                v-if="orderInfo.workorder_schedule_record[0].express_number"
                >快递单号：{{
                  orderInfo.workorder_schedule_record[0].express_number
                }}。</span
              ><span v-show="orderInfo.workorder_schedule_record[0].day"
                >预计需要{{
                  orderInfo.workorder_schedule_record[0].day
                }}天。</span
              >
              <el-popover
                placement="bottom"
                width="600"
                title="跟进记录"
                trigger="click"
              >
                <el-timeline>
                  <el-timeline-item
                    v-for="(item, index) in orderInfo.workorder_schedule_record"
                    icon=" el-icon el-icon-mycircle"
                    :key="index"
                    :color="index === 0 ? '#E2333F' : ''"
                    :timestamp="item.add_time"
                  >
                    <span :style="{ color: index === 0 ? '#E2333F' : '' }">
                      {{ item.content
                      }}<span v-if="item.express_company"
                        >快递公司：{{ item.express_company }}，</span
                      ><span v-if="item.express_number"
                        >快递单号：{{ item.express_number }}。</span
                      ><span v-show="item.day"
                        >预计需要{{
                          orderInfo.workorder_schedule_record[0].day
                        }}天。</span
                      >
                    </span>
                  </el-timeline-item>
                </el-timeline>

                <span slot="reference" class="more">更多></span>
              </el-popover>
            </div>
            <div class="o-date">
              {{ orderInfo.workorder_schedule_record[0].add_time }}
            </div>
          </div>
          <div class="schedule" v-if="service && service.length > 0">
            <div class="o-title">
              处理进度
              <el-popover
                placement="bottom-start"
                width="200"
                trigger="hover"
                content="您可在此查看供应商处理该商品售后的进度。"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </div>
            <div class="o-message">
              {{ service[0].content }}
              <el-popover
                placement="bottom"
                width="600"
                trigger="click"
                content="商品提交售后，将由供应商负责商品的退换/维修服务。上班族客服将及时为您跟进，您可在此查看上班族客服跟进记录。"
              >
                <el-timeline>
                  <el-timeline-item
                    v-for="(item, index) in service"
                    icon=" el-icon el-icon-mycircle"
                    :key="index"
                    :color="index === 0 ? '#E2333F' : ''"
                    :timestamp="item.content"
                  >
                    <span :style="{ color: index === 0 ? '#E2333F' : '' }">
                      {{ item.createDate }}
                    </span>
                  </el-timeline-item>
                </el-timeline>
                <span slot="reference" class="more">更多></span>
              </el-popover>
            </div>
            <div class="o-date">{{ service[0].createDate }}</div>
            <div class="notes" v-if="approveNotes">
              <span>审批意见：</span>{{ approveNotes }}
            </div>
          </div>

          <div v-if="wy_service.status == '待用户寄回'" class="show-wrap">
            <div class="backmsg">请按下方退货信息将商品退回</div>
            <el-row>
              <el-col :span="8">
                <span class="label">收件人姓名：</span>
                {{ wy_service.returnName }}
              </el-col>
              <el-col :span="8">
                <span class="label">收件人手机：</span>
                {{ wy_service.returnMobile }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="label">退货地址：</span>
                {{ wy_service.returnFullAddress }}
              </el-col>
            </el-row>
          </div>
          <div v-if="wy_service" class="show-wrap">
            <el-row>
              <el-col :span="8">
                <span class="label">网易售后状态：</span>
                {{ wy_service.status }}
              </el-col>
              <el-col :span="8">
                <span class="label">退货类型：</span>
                {{ wy_service.returnType }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="label">审核不通过原因：</span>
                {{ wy_service.denyReason }}
              </el-col>
            </el-row>
          </div>
          <div class="show-wrap">
            <el-row>
              <el-col :span="8">
                <span class="label">服务类型：</span>
                {{ orderInfo.service_code_text }}
              </el-col>
              <el-col :span="8">
                <span class="label">订单编号：</span
                >{{ orderInfo.order_info.order_id }}
              </el-col>
              <el-col :span="8">
                <span class="label">商品ID：</span>
                {{
                  orderInfo.order_info && orderInfo.order_info.product_id
                }}</el-col
              >
            </el-row>
            <el-row>
              <el-col :span="8" v-if="orderInfo.supplier_text">
                <span class="label">供应商：</span>{{ orderInfo.supplier_text }}
              </el-col>
              <el-col :span="8" v-if="orderInfo.supplier_order">
                <span class="label">供应商订单号：</span
                >{{ orderInfo.supplier_order }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24"
                ><span class="label">问题描述：</span> {{ orderInfo.remark }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="display: flex;">
                <span class="label"></span>
                <div class="img-show">
                  <div
                    v-for="item in orderInfo.images_code"
                    :key="item"
                    class="img-wraper"
                  >
                    <img :src="item" alt="pic" />
                  </div>
                  <div
                    v-for="(item, index) in imgDataUrl"
                    :key="item"
                    class="img-wraper"
                  >
                    <img :src="item" alt="pic" />

                    <span class="oclose" @click="delImage(index)">X</span>
                  </div>
                  <div
                    class="img-wraper file-upload"
                    v-show="
                      orderInfo.images_code.length + imgDataUrl.length < 5
                    "
                  >
                    <input
                      type="file"
                      name="file"
                      @change="uploadImg"
                      accept=".jpg, .jpeg, .png, .gif, .bmp"
                    />
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col>
                <div
                  v-if="orderInfo.jd_service && orderInfo.jd_service.length > 0"
                  class="after-sale-info"
                >
                  <div class="title">售后进度</div>
                  <div class="van-step">
                    <div
                      v-for="(item, index) in orderInfo.jd_service"
                      :key="index"
                    >
                      <div
                        v-show="serviceLength != index + 1"
                        class="right-line"
                      ></div>
                      <h4>
                        <i class="el-icon el-icon-mycircle"></i>
                        <span>{{ item.afsServiceStepName }}</span>
                        ({{ item.afsApplyTime }})
                      </h4>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row> -->
          </div>
          <div class="work-order" v-if="orderInfo.status == 2">
            <p>{{ needSubmit ? "提交发货信息" : "发货信息" }}</p>
            <div class="info" v-if="needSubmit">
              <div class="submit-list">
                <div class="oInp">
                  <span>运费(元)：</span>
                  <el-input
                    v-model="workorder.freight_money"
                    placeholder="请输入运费"
                    style="width: 300px"
                  />
                </div>
                <div class="oInp">
                  <span>快递公司：</span>
                  <el-input
                    v-model="workorder.express_company"
                    placeholder="请输入快递公司"
                    style="width: 300px"
                  />
                </div>
                <div class="oInp">
                  <span>快递单号：</span>
                  <el-input
                    v-model="workorder.express_code"
                    placeholder="请输入快递单号"
                    style="width: 300px"
                  />
                </div>
                <div class="oInp">
                  <span>发货时间：</span>
                  <el-date-picker
                    v-model="workorder.deliver_date"
                    type="date"
                    placeholder="请选择发货时间"
                    style="width: 300px"
                  ></el-date-picker>
                </div>
              </div>
              <el-button class="btn" @click="submit" v-if="needSubmit"
                >提交</el-button
              >
            </div>
            <div class="info oLeft" v-else>
              <div class="oInp">运费(元)：{{ workorder.freight_money }}</div>
              <div class="oInp">快递公司：{{ workorder.express_company }}</div>
              <div class="oInp">快递单号：{{ workorder.express_code }}</div>
              <div class="oInp">发货时间：{{ workorder.deliver_date }}</div>
            </div>
          </div>
          <div class="operation-btns">
            <el-button class="back" @click="back">返 回</el-button>
            <el-button @click="revoke" v-if="orderInfo.status == '1'"
              >撤销申请</el-button
            >
            <el-button
              class="confirm"
              @click="submitImgs"
              v-if="orderInfo.images_code.length < 5 && addImgShow"
              >提 交</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import LeftUserinfo from "@/components/left-userinfo";
import { setTimeout } from "timers";
import { mixinUpload } from "@/assets/js/imgUpload";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    LeftUserinfo
  },
  data() {
    return {
      id: this.$route.params.workorder_id,
      orderInfo: {
        workorder_schedule_record: [],
        images_code: [],
        order_info: {}
      },
      imgDataUrl: [],
      serviceLength: 0,
      wy_service: "",
      service: [],
      needSubmit: false,
      workorder: {},
      activities: [
        {
          content: "活动按期开始",
          timestamp: "2018-04-15"
        },
        {
          content: "通过审核",
          timestamp: "2018-04-13"
        },
        {
          content: "创建成功",
          timestamp: "2018-04-11"
        }
      ],
      approveNotes: ""
    };
  },
  mixins: [mixinUpload],
  mounted() {
    this.initData();
    this.getExpress();
  },
  computed: {
    addImgShow() {
      if (
        this.orderInfo.status === 1 ||
        this.orderInfo.status === 2 ||
        this.orderInfo.status === 4 ||
        this.orderInfo.status === 10 ||
        this.orderInfo.status === 11
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    toKf() {
      this.$reqGet(
        "/api/store/udesk/orderPage/" + this.orderInfo.order_info.order_id
      ).then(res => {
        if (res.data.success) {
          window.open(res.data.data.url);
        }
      });
    },
    getExpress() {
      this.$reqGet("api/store/workorder/getWorkorderExpress/" + this.id, {
        hideLoading: false
      }).then(res => {
        if (!res.data.data) {
          this.needSubmit = true;
        } else {
          this.needSubmit = false;
          this.workorder = res.data.data;
        }
      });
    },
    initData() {
      this.$reqGet("api/store/workorder/" + this.id).then(res => {
        this.orderInfo = res.data.data;
        if (res.data.data.wy_service) {
          this.wy_service = res.data.data.wy_service;
        }
        this.order_product_id = this.orderInfo.order_product_id;
        this.workorder_id = this.orderInfo.workorder_id;
        this.serviceLength = this.orderInfo.jd_service
          ? this.orderInfo.jd_service.length
          : 0;
        if (
          // this.orderInfo.supplier_text === "京东自营" &&
          this.orderInfo.order_info.supplier === "jd" &&
          this.orderInfo.jd_service &&
          this.orderInfo.jd_service.length > 0 &&
          this.orderInfo.jd_service[0].serviceTrackInfoDTOs &&
          this.orderInfo.jd_service[0].serviceTrackInfoDTOs.length > 0
        ) {
          this.approveNotes = this.orderInfo.jd_service[0].approveNotes;
          this.orderInfo.jd_service[0].serviceTrackInfoDTOs.map(item => {
            this.service.push({
              content: item.context,
              createDate: item.createDate
            });
          });
        }
        if (
          // this.orderInfo.supplier_text === "苏宁易购" &&
          this.orderInfo.order_info.supplier === "suning" &&
          this.orderInfo.sn_service &&
          this.orderInfo.sn_service.length > 0 &&
          this.orderInfo.sn_service[0].afterSrvSchs &&
          this.orderInfo.sn_service[0].afterSrvSchs.length > 0
        ) {
          this.orderInfo.sn_service[0].afterSrvSchs.map(item => {
            this.service.push({
              content: item.afterSrvSch,
              createDate: item.time
            });
          });
        }
        this.service.reverse();
        this.orderInfo.workorder_schedule_record.push({
          content: "您的售后申请已成功提交，我们将持续为你跟进，烦请您耐心等待",
          add_time: this.orderInfo.date_added
        });
      });
    },
    submit() {
      if (!this.workorder.freight_money) {
        this.$message({
          type: "error",
          message: "运费必填！"
        });
        return;
      }
      if (!this.workorder.express_company) {
        this.$message({
          type: "error",
          message: "快递公司必填！"
        });
        return;
      }
      if (!this.workorder.express_code) {
        this.$message({
          type: "error",
          message: "快递单号必填！"
        });
        return;
      }
      if (!this.workorder.deliver_date) {
        this.$message({
          type: "error",
          message: "发货时间必填！"
        });
        return;
      }
      if (Number(this.workorder.freight_money) + "" === NaN + "") {
        this.$message({
          type: "error",
          message: "运费格式不正确！"
        });
        return;
      } else {
        const arr = this.workorder.freight_money.split(".");
        if (arr[1] && arr[1].length > 2) {
          this.$message({
            type: "error",
            message: "运费小数最多输入两位！"
          });
          return;
        }
      }
      this.workorder.order_product_id = this.orderInfo.gjy_order_product_id;
      this.$reqPost(
        "api/store/workorder/addWorkorderExpress",
        this.workorder
      ).then(res => {
        if (res.data.status == 200) {
          this.$message({
            type: "success",
            message: "您的发运信息已提交成功！"
          });
          this.initData();
          this.getExpress();
        }
      });
    },
    back() {
      history.back();
    },
    revoke() {
      this.$confirm("撤销后将不能再次发起申请，确定要撤销该申请吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$reqGet(
          "api/store/workorder/cancelworkorder/" + this.workorder_id
        ).then(res => {
          if (res.data.status == 200) {
            this.$message({
              type: "success",
              message: "撤销成功!"
            });
            setTimeout(() => {
              this.back();
            }, 1000);
          }
        });
      });
    },
    uploadImg(e) {
      this.getTokenMessage(e.target.files[0], key => {
        this.imgDataUrl.push(key);
      });
    },
    delImage(index) {
      this.imgDataUrl.splice(index, 1);
    },
    submitImgs() {
      this.$confirm("你确认提交补充图片吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (this.imgDataUrl.length <= 0) {
          this.$message({
            type: "error",
            message: "请添加新图片后提交!"
          });
          return;
        }
        this.$reqPost("api/store/workorder/add_image/" + this.id, {
          images_code: this.imgDataUrl
        }).then(res => {
          if (res.data.success) {
            this.imgDataUrl = [];
            this.initData();
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.right-refund-wrap {
  // position: relative;
  margin-bottom: 40px;
  min-height: 572px;
  width: 980px;
  margin-left: 220px;
  box-sizing: border-box;
  padding: 10px 25px 0;
  background-color: #fff;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 42px;
    height: 42px;
    border-bottom: 2px solid #dadada;
    margin-bottom: 30px;
    h2 {
      width: 120px;
      border-bottom: 2px solid #e2333f;
      font-size: 20px;
      font-weight: normal;
      margin: 0;
      box-sizing: border-box;
      padding-left: 20px;
    }
    h3 {
      font-size: 18px;
      font-weight: 400;
      color: #e2333f;
    }
  }
  .order-detail-list-wrapper {
    width: 100%;
    color: #222;
    text-align: center;
    .order-list-thead {
      background-color: #fbfbfb;
      height: 40px;
      line-height: 40px;
      border: 1px solid #f5f5f5;
    }
    .order-list-body {
      td {
        border: 0.5px solid #f5f5f5;
      }
      td:first-child {
        padding: 10px;
        text-align: left;
      }
      img {
        width: 60px;
        height: 60px;
        margin-top: 10px;
      }
      .clearfix {
        display: flex;
      }
      p {
        margin-left: 10px;
        display: -webkit-box;
        height: 58px;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
    .red_word {
      color: #e2333f;
    }
  }
}
.schedule {
  padding: 20px;
  border: 1px solid #dadada;
  margin: 20px auto;
  > .o-title {
    font-size: 16px;
    color: #e80000;
    > i {
      cursor: pointer;
    }
  }
  > .o-message {
    margin-top: 20px;
    color: #333;
    font-size: 14px;
    .more {
      color: #1a96d5;
      cursor: pointer;
      margin-left: 5px;
    }
  }
  > .o-date {
    margin-top: 8px;
    color: #777;
  }
  .notes {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid #eee;
    > span {
      color: #e80000;
    }
  }
}
.show-wrap {
  padding: 20px;
  border: 1px solid #dadada;
  margin: 20px auto;
  line-height: 36px;
  .label {
    display: inline-block;
    width: 110px;
    white-space: nowrap;
  }
}
.operation-btns {
  text-align: center;
  .el-button {
    width: 70px;
    height: 40px;
    line-height: 40px;
    padding: 0;
    color: #fff;
    font-size: 14px;
    background: rgba(226, 51, 63, 1);
    border-radius: 5px;
    margin: 20px 30px;
    border: 1px solid rgba(226, 51, 63, 1);
  }
  .back {
    background: rgba(250, 250, 250, 1);
    border: 1px solid rgba(219, 219, 219, 1);
    color: #666;
  }
}
.img-show {
  display: flex;
  .file-upload {
    background: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 100;
      opacity: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    .el-icon-plus {
      color: #bbbbbb;
      font-size: 50px;
    }
  }
}
.img-show > .img-wraper,
.van-uploader {
  position: relative;
  width: 100px;
  height: 100px;
  box-sizing: content-box;
  margin: 0 3px 6px 6px;
  border: 1px solid #ddd;
  .oclose {
    position: absolute;
    top: 0;
    right: 0;
    width: 15px;
    height: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 15px;
    color: #fff;
    background-color: rgba(1, 1, 1, 0.2);
    cursor: pointer;
  }
}
.img-show > div > img {
  width: 100%;
  height: 100%;
}

.after-sale-info {
  padding: 10px 15px;
  margin-top: 10px;
  background: #fff;
}
.van-step {
  h4 {
    font-weight: normal;
    span {
      display: inline-block;
      font-size: 14px;
      min-width: 80px;
    }
  }
  > div {
    position: relative;
    .right-line {
      position: absolute;
      width: 1px;
      height: 20px;
      background: #ddd;
      left: 6.5px;
      top: 15px;
    }
  }
}

.van-step > div:last-child {
  color: #f44 !important;
}
.backmsg {
  color: #ff3030;
}
.work-order {
  margin: 0 auto;
  > p {
    font-size: 20px;
    color: #666;
  }
  .info {
    border: 1px solid #dcdfe6;
    padding: 20px;
    .submit-list {
      display: flex;
      flex-wrap: wrap;
      .oInp {
        width: 50%;
        display: flex;
        align-items: center;
        margin: 12px 0;
        > span {
          &::before {
            content: "*";
            color: #e2333f;
          }
        }
      }
    }
    .btn {
      display: block;
      background: #e2333f;
      border: 1px solid #e2333f;
      color: #fff;
      width: 100px;
      text-align: center;
      margin: 0 auto;
    }
  }
  .oLeft {
    .oInp {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/refund-detail.vue